import { connect } from 'react-redux';
import { isAlertVisible } from '../BreadcrumbsHelper';
import { createAlert } from '../BreadcrumbsActions';
import BreadcrumbTooltip from './BreadcrumbTooltip';

function mapStateToProps(state, ownProps) {
  return {
    isAlertVisible: isAlertVisible(ownProps.breadcrumb.toJS()),
  };
}

const mapDispatchToProps = {
  createAlert,
};

export default connect(mapStateToProps, mapDispatchToProps)(BreadcrumbTooltip);
